export default {
	units: {
		position: 'Lage',
		modeOfUse: 'Verwaltungsart',
		area: 'Fläche in m²',
		unit: 'Wohnung',
		commercial: 'Gewerbe',
		partialOwnership: 'Teileigentum',
		garage: 'Garage',
		tax: 'MwSt optiert',
	},
}
